export default __webpack_public_path__ + "assets/images/login-image1.jpg";